<template>
  <div class="app-container warehouse-overview">
    <div class="page-header">
      <div class="page-header__left">
        <h2 class="page-header__title">委外库存总览</h2>
        <p class="page-header__desc">
          库存查询入口，仅展示本账号授权范围内的协同委外库存
        </p>
      </div>
      <div class="page-header__actions">
        <!-- <el-button size="small" :loading="loading" @click="refreshAll">
          刷新库存
        </el-button>
        <el-button type="primary" size="small" @click="handleQuery">
          查询委外库存
        </el-button>
        <el-button size="small" @click="goSummary">库存汇总</el-button>
        <el-button size="small" @click="goWarehouse">库存明细</el-button> -->
      </div>
    </div>

    <div class="stat-panel" v-loading="statLoading">
      <el-row :gutter="16">
        <el-col
          v-for="item in statCards"
          :key="item.key"
          :xs="24"
          :sm="12"
          :md="6"
        >
          <div class="stat-card" :class="'stat-card--' + item.tone">
            <div
              class="stat-card__accent"
              :style="{ background: item.accent }"
            />
            <div class="stat-card__body">
              <div class="stat-card__title-row">
                <span class="stat-card__title">{{ item.title }}</span>
              </div>
              <div class="stat-card__count" :style="{ color: item.color }">
                {{ item.count }}
              </div>
              <div class="stat-card__desc">{{ item.desc }}</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <el-row :gutter="16" class="main-row">
      <el-col :xs="24" :lg="16">
        <div class="query-panel">
          <div class="panel-head">
            <div>
              <div class="panel-head__eyebrow">快捷查询</div>
              <div class="panel-head__title">委外库存查询入口</div>
            </div>
            <!-- <el-tag size="mini" type="info" effect="plain">授权可见</el-tag> -->
          </div>

          <div class="query-bar">
            <el-input
              v-model="searchData.searchString"
              size="small"
              clearable
              class="query-bar__search"
              placeholder="输入物料编码、名称、批次、委外单号"
              @keyup.enter.native="handleQuery"
            />
            <!-- <el-select
              v-model="searchData.bizDocKind"
              size="small"
              clearable
              placeholder="全部业务类型"
              class="query-bar__select"
            >
              <el-option label="全部业务类型" :value="null" />
              <el-option
                v-for="opt in bizDocKindOptions"
                :key="opt.value"
                :label="opt.label"
                :value="opt.value"
              />
            </el-select>
            <el-select
              v-model="searchData.productionOrMaterial"
              size="small"
              clearable
              placeholder="全部物料状态"
              class="query-bar__select"
            >
              <el-option label="全部物料状态" value="" />
              <el-option
                v-for="opt in materialStatusOptions"
                :key="opt.value"
                :label="opt.label"
                :value="opt.value"
              />
            </el-select> -->
            <el-button type="primary" size="small" @click="handleQuery">
              进入查询
            </el-button>
          </div>

          <el-table
            v-loading="listLoading"
            :data="list"
            border
            stripe
            size="small"
            class="query-table"
            empty-text="暂无库存数据"
          >
            <el-table-column
              prop="baseMaterialNumber"
              label="物料编码"
              min-width="120"
              show-overflow-tooltip
            />
            <el-table-column
              prop="baseMaterialName"
              label="物料名称"
              min-width="140"
              show-overflow-tooltip
            />
            <el-table-column label="业务类型" width="100" align="center">
              <template slot-scope="{ row }">
                <el-tag
                  size="mini"
                  :type="Number(row.bizDocKind) === 1 ? 'warning' : ''"
                >
                  {{ row._bizDocKindLabel }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column
              prop="batchNumber"
              label="批次"
              min-width="120"
              show-overflow-tooltip
            >
              <template slot-scope="{ row }">
                {{ row.batchNumber || '--' }}
              </template>
            </el-table-column>
            <el-table-column
              prop="valueMaterialQuantity"
              label="结存数量"
              width="110"
              align="right"
            >
              <template slot-scope="{ row }">
                <span class="qty-text">
                  {{ formatQty(row.valueMaterialQuantity) }}
                </span>
                <span class="qty-unit">
                  {{ row.baseMaterialUnitName || '' }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="outsourcingDocNumber"
              label="委外单号"
              min-width="130"
              show-overflow-tooltip
            >
              <template slot-scope="{ row }">
                {{ row.outsourcingDocNumber || '--' }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="200" fixed="right">
              <template slot-scope="{ row }">
                <el-button type="text" size="mini" @click="goWarehouseDetail(row)">
                  查看明细
                </el-button>
                <el-button type="text" size="mini" @click="goFlow(row)">
                  查看异动
                </el-button>
                <el-button type="text" size="mini" @click="goBatch(row)">
                  查看批次
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <div class="query-pager">
            <pagination
              :total="listQuery.total"
              :page.sync="listQuery.pageNum"
              :limit.sync="listQuery.pageSize"
              :page-sizes="[10, 20, 50]"
              style="text-align: right"
              @pagination="loadList"
            />
          </div>
        </div>
      </el-col>

      <el-col :xs="24" :lg="8">
        <div class="alert-panel" v-loading="alertLoading">
          <div class="panel-head">
            <div>
              <div class="panel-head__eyebrow">库存提醒</div>
              <div class="panel-head__title">待办入口</div>
            </div>
            <!-- <el-tag size="mini" type="danger" effect="plain">
              {{ alertTotal }}项
            </el-tag> -->
          </div>

          <div
            v-for="item in alertCards"
            :key="item.key"
            class="alert-card"
            :class="'alert-card--' + item.tone"
            @click="item.onClick"
          >
            <div class="alert-card__top">
              <span class="alert-card__title">{{ item.title }}</span>
              <span class="alert-card__count">{{ item.count }}</span>
            </div>
            <p class="alert-card__desc">{{ item.desc }}</p>
            <div v-if="item.previews && item.previews.length" class="alert-card__list">
              <div
                v-for="(preview, idx) in item.previews"
                :key="item.key + '-' + idx"
                class="alert-card__preview"
              >
                {{ preview }}
              </div>
            </div>
            <div class="alert-card__action">{{ item.actionText }}</div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {
  outsourcingWarehouse_getInventoryStat,
  outsourcingWarehouse_list,
  outsorRequisitionDoc_listTwo,
  processOutsourcingRequisitionDoc_listWithDetail,
  outsourcingtowarehouse_getVagueList,
} from "@/api/myController/outsourcing";
import {
  normalizeInventoryStatCards,
  buildInventoryStatPayload,
  formatInventoryQtyLabel,
} from "@/utils/outsourcingWarehouseSummary";
import {
  WAREHOUSE_BIZ_DOC_KIND,
  WAREHOUSE_BIZ_DOC_KIND_OPTIONS,
  WAREHOUSE_MATERIAL_STATUS_OPTIONS,
  getWarehouseBizDocKindLabel,
  parseWarehouseSpec,
  buildWarehouseListPayload,
} from "@/utils/outsourcingWarehouse";
import {
  SUPPLIER_CONFIRM_STATUS,
} from "@/utils/outsourcingReceiveConfirm";
import { COOPERATIVE_DOC_STATUS } from "@/utils/outsourcingFinishDelivery";

export default {
  name: "outsourcingProduct_warehouseOverview",
  data() {
    return {
      loading: false,
      statLoading: false,
      listLoading: false,
      alertLoading: false,
      statCards: normalizeInventoryStatCards(),
      searchData: {
        searchString: "",
        bizDocKind: null,
        productionOrMaterial: "",
      },
      list: [],
      listQuery: {
        total: 0,
        pageNum: 1,
        pageSize: 10,
      },
      bizDocKindOptions: WAREHOUSE_BIZ_DOC_KIND_OPTIONS,
      materialStatusOptions: WAREHOUSE_MATERIAL_STATUS_OPTIONS,
      pendingReceiveCount: 0,
      pendingReceivePreviews: [],
      lockedDeliveryCount: 0,
      lockedDeliveryPreviews: [],
      batchedQuantityLabel: "0",
    };
  },
  computed: {
    alertTotal() {
      return (
        (this.pendingReceiveCount > 0 ? 1 : 0) +
        (this.lockedDeliveryCount > 0 ? 1 : 0) +
        1
      );
    },
    alertCards() {
      return [
        {
          key: "pendingReceive",
          title: "在途待收料",
          count: this.pendingReceiveCount,
          tone: "warning",
          desc: "本厂已发料、委外商尚未完全确认收料的发料单",
          previews: this.pendingReceivePreviews,
          actionText: "前往产品/工序发料单处理 →",
          onClick: () => this.goPendingReceive(),
        },
        {
          key: "lockedDelivery",
          title: "出货占用",
          count: this.lockedDeliveryCount,
          tone: "info",
          desc: "产品委外出货单处于已占用库存状态（待审核流转）",
          previews: this.lockedDeliveryPreviews,
          actionText: "前往产品委外出货单 →",
          onClick: () => this.goLockedDelivery(),
        },
        {
          key: "batchInventory",
          title: "批次库存台账",
          count: this.batchedQuantityLabel,
          tone: "success",
          desc: "已维护批次号的协同库存结存，可按批次核查台账",
          previews: [],
          actionText: "打开批次库存台账 →",
          onClick: () => this.goBatch(),
        },
      ];
    },
  },
  mounted() {
    this.refreshAll();
  },
  methods: {
    formatQty: formatInventoryQtyLabel,
    refreshAll() {
      this.loading = true;
      Promise.all([
        this.loadStat(),
        this.loadList(),
        this.loadAlerts(),
      ]).finally(() => {
        this.loading = false;
      });
    },
    handleQuery() {
      this.listQuery.pageNum = 1;
      this.loadList();
    },
    loadStat() {
      this.statLoading = true;
      return outsourcingWarehouse_getInventoryStat(
        buildInventoryStatPayload({
          searchString: this.searchData.searchString,
          bizDocKind: this.searchData.bizDocKind,
        })
      )
        .then((res) => {
          const data = res.data.data || {};
          this.statCards = normalizeInventoryStatCards(data);
          this.batchedQuantityLabel = formatInventoryQtyLabel(
            data.batchedQuantity
          );
        })
        .catch(() => {
          this.statCards = normalizeInventoryStatCards({});
          this.batchedQuantityLabel = "0";
        })
        .finally(() => {
          this.statLoading = false;
        });
    },
    loadList() {
      this.listLoading = true;
      return outsourcingWarehouse_list(
        buildWarehouseListPayload({
          searchData: this.searchData,
          pageParam: {
            pageNum: this.listQuery.pageNum,
            pageSize: this.listQuery.pageSize,
          },
          orderParam: [],
        })
      )
        .then((res) => {
          const pageData = res.data.data || {};
          this.list = (pageData.dataList || []).map((item) => {
            const row = parseWarehouseSpec(item);
            row._bizDocKindLabel = getWarehouseBizDocKindLabel(row.bizDocKind);
            return row;
          });
          this.listQuery.total = pageData.totalCount || 0;
        })
        .catch(() => {
          this.list = [];
          this.listQuery.total = 0;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    loadAlerts() {
      this.alertLoading = true;
      const pageParam = { pageNum: 1, pageSize: 2 };
      const orderParam = [{ asc: false, fieldName: "createTime" }];

      const loadProductPending = () =>
        outsorRequisitionDoc_listTwo({
          orderParam,
          outsorRequisitionDocFilter: {
            statusSupplierConfirm: SUPPLIER_CONFIRM_STATUS.NONE,
          },
          pageParam,
        })
          .then((res) => {
            const pageData = res.data.data || {};
            return {
              total: pageData.totalCount || 0,
              list: pageData.dataList || [],
            };
          })
          .catch(() => ({ total: 0, list: [] }));

      const loadProcessPending = () =>
        processOutsourcingRequisitionDoc_listWithDetail({
          orderParam,
          processOutsourcingRequisitionDocDtoFilter: {
            statusSupplierConfirm: SUPPLIER_CONFIRM_STATUS.NONE,
          },
          processOutsourcingRequisitionDocDetailDtoFilter: {},
          pageParam,
        })
          .then((res) => {
            const pageData = res.data.data || {};
            return {
              total: pageData.totalCount || 0,
              list: pageData.dataList || [],
            };
          })
          .catch(() => ({ total: 0, list: [] }));

      const loadLockedDelivery = () =>
        outsourcingtowarehouse_getVagueList({
          orderParam,
          outsourcingtowarehouseFilter: {
            statusCooperativeDoc: COOPERATIVE_DOC_STATUS.LOCKED,
          },
          pageParam,
        })
          .then((res) => {
            const pageData = res.data.data || {};
            return {
              total: pageData.totalCount || 0,
              list: pageData.dataList || [],
            };
          })
          .catch(() => ({ total: 0, list: [] }));

      return Promise.all([
        loadProductPending(),
        loadProcessPending(),
        loadLockedDelivery(),
      ])
        .then(([productPending, processPending, lockedDelivery]) => {
          this.pendingReceiveCount =
            (productPending.total || 0) + (processPending.total || 0);
          const pendingRows = [
            ...productPending.list.map((row) => ({
              ...row,
              _kind: "产品",
              _number:
                row.outsorRequisitionDocNumber ||
                row.materialRequisitionDocNumber ||
                row.baseOutsourcingDocNumber ||
                "--",
            })),
            ...processPending.list.map((row) => ({
              ...row,
              _kind: "工序",
              _number:
                row.processOutsourcingRequisitionDocNumber ||
                row.baseProcessOutsourcingDocNumber ||
                row.processOutsourcingDocNumber ||
                "--",
            })),
          ].slice(0, 2);
          this.pendingReceivePreviews = pendingRows.map(
            (row) => `${row._kind}发料 ${row._number} · 待收料确认`
          );

          this.lockedDeliveryCount = lockedDelivery.total || 0;
          this.lockedDeliveryPreviews = (lockedDelivery.list || [])
            .slice(0, 2)
            .map((row) => {
              const number =
                row.outsourcingtowarehouseNumber ||
                row.baseOutsourcingDocNumber ||
                "--";
              const material = row.baseMaterialName || row.baseMaterialNumber || "";
              return material
                ? `出货单 ${number} · ${material}`
                : `出货单 ${number} · 已占用库存`;
            });
        })
        .finally(() => {
          this.alertLoading = false;
        });
    },
    goSummary() {
      this.$router.push({ name: "outsourcingProduct_warehouseSummary" });
    },
    goWarehouse() {
      this.$router.push({
        name: "outsourcingProduct_warehouse",
        query: this.buildWarehouseQuery(),
      });
    },
    goWarehouseDetail(row) {
      const query = this.buildWarehouseQuery(row);
      this.$router.push({
        name: "outsourcingProduct_warehouse",
        query,
      });
    },
    buildWarehouseQuery(row) {
      const query = {};
      const bizDocKind =
        row && row.bizDocKind !== undefined && row.bizDocKind !== null
          ? row.bizDocKind
          : this.searchData.bizDocKind;
      if (bizDocKind !== null && bizDocKind !== undefined && bizDocKind !== "") {
        query.bizDocKind = bizDocKind;
      }
      if (this.searchData.searchString) {
        query.searchString = this.searchData.searchString;
      }
      if (row) {
        if (row.baseOutsourcingDocId) {
          query.baseOutsourcingDocId = row.baseOutsourcingDocId;
        }
        if (row.outsourcingDocNumber) {
          query.outsourcingDocNumber = row.outsourcingDocNumber;
        }
        if (
          Number(row.bizDocKind) === WAREHOUSE_BIZ_DOC_KIND.PROCESS &&
          (row.baseProcessOutsourcingDocId || row.baseOutsourcingDocId)
        ) {
          query.processOutsourcingDocId =
            row.baseProcessOutsourcingDocId || row.baseOutsourcingDocId;
        }
      }
      return query;
    },
    goFlow(row) {
      const query = {};
      if (row && row.outsourcingWarehouseId) {
        query.outsourcingWarehouseId = row.outsourcingWarehouseId;
        if (row.baseMaterialNumber) {
          query.baseMaterialNumber = row.baseMaterialNumber;
        }
        if (row.baseMaterialName) {
          query.baseMaterialName = row.baseMaterialName;
        }
        if (row.batchNumber) {
          query.batchNumber = row.batchNumber;
        }
      }
      this.$router.push({
        name: "outsourcingProduct_warehouseFlow",
        query,
      });
    },
    goBatch(row) {
      const query = {};
      if (row) {
        if (row.bizDocKind !== undefined && row.bizDocKind !== null) {
          query.bizDocKind = row.bizDocKind;
        }
        if (row.batchNumber) {
          query.batchNumber = row.batchNumber;
        } else if (row.baseMaterialNumber) {
          query.searchString = row.baseMaterialNumber;
        }
      } else if (
        this.searchData.bizDocKind !== null &&
        this.searchData.bizDocKind !== undefined &&
        this.searchData.bizDocKind !== ""
      ) {
        query.bizDocKind = this.searchData.bizDocKind;
      }
      this.$router.push({
        name: "outsourcingProduct_warehouseBatchInventory",
        query,
      });
    },
    goPendingReceive() {
      this.$router.push({ name: "outsourcingProduct_materials" });
    },
    goLockedDelivery() {
      this.$router.push({ name: "outsourcingProduct_finish" });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.warehouse-overview {
  padding-bottom: 24px;
}

.page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 16px;
}

.page-header__title {
  margin: 0;
  color: #1476c3;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.3;
}

.page-header__desc {
  margin: 6px 0 0;
  color: #909399;
  font-size: 13px;
}

.page-header__actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
}

.stat-panel {
  margin-bottom: 16px;
  padding: 16px 16px 0;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
}

.stat-card {
  position: relative;
  display: flex;
  min-height: 118px;
  margin-bottom: 16px;
  overflow: hidden;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  border: 1px solid #ebeef5;
  border-radius: 10px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.stat-card__accent {
  width: 4px;
  flex-shrink: 0;
}

.stat-card__body {
  flex: 1;
  min-width: 0;
  padding: 16px 18px;
}

.stat-card__title {
  color: #606266;
  font-size: 13px;
  font-weight: 600;
}

.stat-card__count {
  margin: 10px 0;
  font-size: 30px;
  font-weight: 700;
  line-height: 1.1;
  font-variant-numeric: tabular-nums;
}

.stat-card__desc {
  color: #909399;
  font-size: 12px;
  line-height: 1.5;
}

.stat-card--primary {
  background: linear-gradient(135deg, #f5f9ff 0%, #ffffff 55%);
}

.stat-card--info {
  background: linear-gradient(135deg, #f0f7ff 0%, #ffffff 55%);
}

.stat-card--warning {
  background: linear-gradient(135deg, #fff8ed 0%, #ffffff 55%);
}

.stat-card--success {
  background: linear-gradient(135deg, #f3fbf6 0%, #ffffff 55%);
}

.main-row {
  margin-bottom: 8px;
}

.query-panel,
.alert-panel {
  min-height: 100%;
  padding: 16px 20px 12px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
}

.panel-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 14px;
}

.panel-head__eyebrow {
  margin-bottom: 4px;
  color: #909399;
  font-size: 12px;
}

.panel-head__title {
  color: #303133;
  font-size: 18px;
  font-weight: 700;
}

.query-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
}

.query-bar__search {
  flex: 1 1 220px;
  min-width: 200px;
}

.query-bar__select {
  width: 150px;
}

.query-table {
  width: 100%;
}

.qty-text {
  color: #303133;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

.qty-unit {
  margin-left: 4px;
  color: #909399;
  font-size: 12px;
}

.query-pager {
  margin-top: 10px;
  overflow: hidden;
}

.alert-card {
  margin-bottom: 12px;
  padding: 14px 14px 12px;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    border-color: #c0c4cc;
    box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
  }

  &:last-child {
    margin-bottom: 0;
  }
}

.alert-card--warning {
  background: linear-gradient(180deg, #fffaf0 0%, #ffffff 70%);
}

.alert-card--info {
  background: linear-gradient(180deg, #f5f9ff 0%, #ffffff 70%);
}

.alert-card--success {
  background: linear-gradient(180deg, #f3fbf6 0%, #ffffff 70%);
}

.alert-card__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.alert-card__title {
  color: #303133;
  font-size: 14px;
  font-weight: 600;
}

.alert-card__count {
  color: #1476c3;
  font-size: 20px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.alert-card__desc {
  margin: 0 0 8px;
  color: #909399;
  font-size: 12px;
  line-height: 1.5;
}

.alert-card__list {
  margin-bottom: 8px;
}

.alert-card__preview {
  padding: 6px 8px;
  margin-bottom: 6px;
  color: #606266;
  font-size: 12px;
  line-height: 1.4;
  background: rgba(255, 255, 255, 0.85);
  border-radius: 4px;

  &:last-child {
    margin-bottom: 0;
  }
}

.alert-card__action {
  color: #1476c3;
  font-size: 12px;
  font-weight: 600;
}
</style>
